const useQueryParams = () => new URLSearchParams(window.location.search);

export default useQueryParams;
